import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import { MQ_MEDIUM } from 'constants/mq';

// Going to explicitly ignore browsers that don't support Grid for now
export default css`
  .TeaserRecipeCard {
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.15);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .TeaserRecipeCard__recipeInfo {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 0.5rem 0.5rem;
  }
  .TeaserRecipeCard__recipeNotes {
    margin-top: 0.5rem;
    background-color: ${warmGrays[0]};
    padding: 0.5rem 1rem;
    border-radius: 15px;
    font-size: 14px;
    color: ${warmGrays[8]};
    max-height: 3rem;
    overflow: hidden;
  }
  .TeaserRecipeCard__recipeRatingLabel {
    font-size: 12px;
    font-weight: normal;
  }

  .TeaserRecipeCard__isUpdatingMessageBox {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: ${warmGrays[7]};
  }

  .TeaserRecipeCard__isUpdatingMessageBox span {
    font-size: var(--fontScaleNeg1);
    font-style: italic;
    color: #fff;
    padding: 0.5rem 1.5rem;
  }

  .TeaserRecipeCard__showEditForm {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 0.8rem;
  }

  .TeaserRecipeCard__showEditForm a {
    color: ${sharedPalette.watermelon};
    display: flex;
    text-transform: uppercase;
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .TeaserRecipeCard__showEditForm :global(svg) {
    margin-right: 0.5rem;
  }

  .TeaserRecipeCard__editForm {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: #fff;
    background: rgba(255, 255, 255, 0.8);
    overflow-y: scroll;
  }

  :global(.TeaserRecipeCard__editFormModal) {
    max-width: 414px;
    margin: 2rem auto;
    background: rgba(255, 255, 255, 1);
    position: relative;
    box-shadow: 0px 0px 11px 0px #ccc;
    overflow: scroll;
  }

  .TeaserRecipeCard__editFormHeader {
    width: 100%;
    padding: 0.65rem;
  }

  .TeaserRecipeCard__editFormHeader a {
    display: flex;
    align-items: center;
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    color: black;
    text-transform: uppercase;
  }

  .TeaserRecipeCard__editFormHeader a span {
    padding-left: 0.1rem;
  }

  .TeaserRecipeCard__editFormHeader :global(svg) {
    width: 0.65rem; /* magic number that keeps back button icon same height as text */
  }

  :global(.TeaserRecipeCard__editFormModal
      .RecipeBoxTagForm
      .RecipeBoxTagForm__myTags
      strong) {
    text-transform: uppercase;
    color: black;
  }

  :global(.TeaserRecipeCard__editFormModal .RecipeBoxTagForm) {
    background: ${warmGrays[0]};
    padding-left: 10px;
    padding-right: 10px;
  }

  :global(.TeaserRecipeCard__editFormModal .RecipeBoxTagForm__addTagForm) {
    padding: 1rem;
  }

  .TeaserRecipeCard :global(.Error__message) {
    font-size: var(--fontScaleNeg2);
    color: red;
  }

  .TeaserRecipeCard__editInfoRating :global(.RecipeRating__text) {
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    text-transform: none;
  }

  .TeaserRecipeCard__editInfoRating :global(.RecipeRating__rateNow) {
    font-size: var(--fontScaleNeg1);
  }

  .TeaserRecipeCard__recipeRating :global(.RecipeRating__rating) {
    flex-direction: column;
    align-items: flex-start;
  }

  .TeaserRecipeCard__recipeRating :global(.RecipeRating__text) {
    font-size: 12px;
    margin-bottom: 0.25rem;
  }

  .TeaserRecipeCard__recipeRating :global(.RecipeRating__star) {
    width: 1em;
    height: 1em;
  }

  @media screen and ${MQ_MEDIUM} {
    .TeaserRecipeCard__recipeInfo {
      padding: 0.75rem;
    }

    .TeaserRecipeCard__recipeRating :global(.RecipeRating__star) {
      width: 1.5em;
      height: 1.5em;
    }

    .TeaserRecipeCard__editInfoNotes button {
      font-size: var(--fontScaleNeg2);
    }
  }
`;
